var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-block",style:(`z-index:${_vm.z}`)},[_c('div',{staticClass:"loader"},[_vm._v("111s")])])
}
var staticRenderFns = []

export { render, staticRenderFns }